import LogoApp from '@/components/UI/Logo'
import Spinner from '@/components/UI/Spinner'
import ButtonForms from '@/components/UI/ButtonForms'

export default [
    LogoApp, Spinner, ButtonForms
]